module.exports = __webpack_public_path__ + "54cf98f5/img/link-icon.fa09ed66.svg";